/* eslint-disable no-unneeded-ternary */
import React, { useState, useRef, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useScrollPosition } from 'shared/hooks';

import Logo from 'assets/logo.png';
import {
  faList,
  faChartBar,
  faCalculator,
  faMedal,
  faChartLine,
  faEdit,
  faShoppingCart,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faWifi,
  faSync,
  faCheck,
  faClock,
  faTimes,
  faPencilAlt,
  faGreaterThan,
  faLessThan,
  faHandHoldingUsd,
} from '@fortawesome/free-solid-svg-icons';

import NavbarButton from './NavbarButton/NavbarButton';
import Styles from './Navbar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Check } from 'components/Template';

import { SyncContext } from 'contexts/sync';

import moment from 'moment';
import 'moment/min/locales';
import { C } from 'shared/helpers';

moment.locale('pt');

const Navbar = ({ toggleSidebar, history, sidebarOpenState, etecStatus }) => {
  const { Navbar, Offset, Options, Status, Update, UncompleteSync, Icon, Visible } = Styles;
  const syncs = useSelector(state => state.queue.sync);
  const { lock, lockSync, unlockSync, inEditableContext } = useContext(
    SyncContext,
  );
  const [hideOnScroll, setHideOnScroll] = useState(true);
  const remainingSyncs = Object.entries(syncs).filter(([, date]) => (date === '0001-01-01'));
  const updateAvailable = useSelector((state) => state.syncs.updateAvailable);
  const [triedSync, setTriedSync] = useState(false);

  const latestSync =
    syncs &&
    Object.values(syncs)
      .filter((x) => typeof x === 'string')
      .sort(() => -1)[0];

  const navRef = useRef();

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll],
  );
  const queue = useSelector((state) => state.queue);
  const { data, loading, sending, online } = queue;

  useEffect(() => {
    if (sending) {
      setTriedSync(true);
    }
  }, [sending]);

  const toggleSync = () => (lock ? unlockSync() : lockSync());
  const isPendingSync = triedSync && (!sending && !loading) && (remainingSyncs.length > 0);

  return (
    <div
      style={{
        transform: !hideOnScroll ? 'translateY(-50%)' : 'translateY(0%)',
      }}
      className={Navbar}
    >
      <div className={Offset}>
        <div
          className={Status}
          style={{ transform: sidebarOpenState ? 'translateX(360px)' : null }}
        >
          <img
            alt='Logo'
            onClick={() => history.push('/')}
            style={{ cursor: 'pointer' }}
            src={Logo}
          />
          <hr />
          <div>
            <div id='connection_status'>
              <FontAwesomeIcon
                icon={faWifi}
                style={{
                  color: online ? 'green' : 'grey',
                  marginRight: '5px',
                  display: 'inline',
                }}
              />
              {online ? 'Conectado' : 'Desconectado'}
            </div>
            <div id='sync_status'>
              <FontAwesomeIcon
                icon={
                  online && !lock
                    ? inEditableContext
                      ? faPencilAlt
                      : faCheck
                    : inEditableContext
                      ? faPencilAlt
                      : data.length
                        ? faClock
                        : faTimes
                }
                style={{
                  color: online && !lock ? 'green' : 'grey',
                  margin:
                    online && !lock
                      ? '0px 7px 0px 1px'
                      : data.length
                        ? '0px 7px 0px 2px'
                        : '0px 6px 0px 3px',
                  display: !loading ? 'inline' : 'none',
                }}
              />
              <FontAwesomeIcon
                spin
                icon={faSync}
                style={{
                  color: online ? 'green' : 'grey',
                  marginRight: '5px',
                  display: loading ? 'inline' : 'none',
                }}
              />
              {(!loading &&
                online &&
                !lock &&
                !data.length &&
                !inEditableContext &&
                'Atualizado') ||
                null}
              {(online &&
                !lock &&
                !data.length &&
                inEditableContext &&
                'Aguardando edições...') ||
                null}
              {((loading || (online && !lock && data.length)) &&
                'Atualizando...') ||
                null}
              {(lock && data.length && `${data.length} aguardando`) || null}
              {(!loading &&
                lock &&
                !data.length &&
                (latestSync === '0001-01-01'
                  ? 'Aguardando atualização'
                  : `Última atualização ${moment(latestSync).fromNow()}`)) ||
                null}
              {(!online &&
                !lock &&
                !inEditableContext &&
                'Aguardando conexão') ||
                null}
              {(!online &&
                !lock &&
                inEditableContext &&
                'Aguardando edições') ||
                null}
            </div>
            <div style={{ display: 'flex' }}>
              <Check value={!lock} setter={toggleSync} />
              {!lock
                ? online && !inEditableContext
                  ? 'Sincronizar automaticamente'
                  : 'Sincronizar assim que possível'
                : 'Não sincronizar automaticamente'}
            </div>
          </div>
          <div className={C(UncompleteSync, [isPendingSync, Visible])}>
            <FontAwesomeIcon icon={faTimes} className={Icon} />
            <div>
              <p>
                Houve um erro ao sincronizar os dados, 
                aguarde a próxima sincronização antes de usar a aplicação
              </p>
            </div>
          </div>
          <div className={Update}>
            {updateAvailable && (
              <>
                <p>Atualização disponível</p>
                <button onClick={() => window.location.reload()}>Atualizar</button>
              </>
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          scrollLeft: '-150',
          display: !online && !etecStatus ? 'none' : undefined,
        }}
        ref={navRef}
        className={Options}
      >
        <button
          id='menu_btn'
          style={{
            position: 'absolute',
            left: '-15px',
          }}
          onClick={toggleSidebar}
        >
          MENU
        </button>
        <Route
          path='/pem/:section'
          render={() => (
            <div>
              <NavbarButton
                id='navbar_scroll_left'
                style={{ float: 'left', position: 'absolute', left: '85px' }}
                icon={faAngleDoubleLeft}
                label={''}
                section={''}
                onClickFunc={() => {
                  const step = (i) => {
                    if (i) {
                      navRef.current.scrollLeft -= i;
                      window.requestAnimationFrame(step.bind(undefined, i - 1));
                    }
                  };
                  window.requestAnimationFrame(step.bind(undefined, 30));
                }}
              />
              <NavbarButton
                id='navbar_btn_dad_iniciais'
                style={{ marginLeft: '220px' }}
                icon={faList}
                label={'Dados Iniciais'}
                section={'data'}
              />
              <NavbarButton
                id='navbar_btn_nut_convencional'
                icon={faList}
                label={'1 - Nutrição Convencional'}
                section={'nutrition/conventional'}
              />
              <NavbarButton
                id='navbar_btn_nut_sqm'
                icon={faList}
                label={'2 - Nutrição SQM VITAS'}
                section={'nutrition/sqmvitas'}
              />
              <NavbarButton
                id='navbar_btn_comp_nutricional'
                icon={[faLessThan, faGreaterThan]}
                label={'3 - Comparativo Nutricional'}
                section={'nutrition/comparison'}
              />
              <NavbarButton
                id='navbar_btn_comp_fontes'
                icon={[faLessThan, faGreaterThan]}
                label={'3 A - Comparativo das Fontes de N'}
                section={'nutrition/sources'}
              />
              <NavbarButton
                id='navbar_btn_graficos'
                icon={faChartBar}
                label={'3 A - Gráficos'}
                section={'charts'}
              />
              <NavbarButton
                id='navbar_btn_eco_indiretas'
                icon={faHandHoldingUsd}
                label={'4 - Economias Indiretas'}
                section={'savings'}
              />
              <NavbarButton
                id='navbar_btn_exp_minima'
                icon={faCalculator}
                label={'5 - Expectativa Mínima'}
                section={'forecast'}
              />
              <NavbarButton
                id='navbar_btn_imp_qualidade'
                icon={faMedal}
                label={'6 - Impactos de Qualidade'}
                section={'quality'}
              />
              <NavbarButton
                id='navbar_btn_resumo'
                icon={faChartLine}
                label={'7 - Resumo'}
                section={'report'}
              />
              <NavbarButton
                id='navbar_btn_outros'
                icon={faEdit}
                label={'8 - Outros'}
                section={'others'}
              />
              <NavbarButton
                id='navbar_btn_vol_compras'
                icon={faShoppingCart}
                label={'9 - Volume de Compras'}
                section={'cart'}
                style={{ marginRight: '240px' }}
              />
              <NavbarButton
                id='navbar_scroll_right'
                style={{ float: 'right', position: 'absolute', right: '-15px' }}
                icon={faAngleDoubleRight}
                label={''}
                section={''}
                onClickFunc={() => {
                  const step = (i) => {
                    if (i) {
                      navRef.current.scrollLeft += i;
                      window.requestAnimationFrame(step.bind(undefined, i - 1));
                    }
                  };
                  window.requestAnimationFrame(step.bind(undefined, 30));
                }}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
};

Navbar.defaultProps = {
  sidebarOpenState: false,
};

Navbar.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  sidebarOpenState: PropTypes.bool,
  etecStatus: PropTypes.bool.isRequired,
};

export default withRouter(Navbar);
